"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Showcase = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importStar(require("react"));

var root_1 = require("./styled/root");

var sections_1 = require("./styled/sections");

var use_showcase_1 = require("./use-showcase");

var Showcase = function Showcase(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      children = _a.children,
      _b = _a.blurColor,
      blurColor = _b === void 0 ? 'grey-white' : _b,
      _c = _a.blurAreaWidth,
      blurAreaWidth = _c === void 0 ? 6 : _c,
      _d = _a.distanceBetweenItems,
      distanceBetweenItems = _d === void 0 ? 1 : _d,
      _e = _a.distanceFromHorizontalEdges,
      distanceFromHorizontalEdges = _e === void 0 ? 1 : _e,
      _f = _a.scrollIconSize,
      scrollIconSize = _f === void 0 ? 'small' : _f,
      _g = _a.forwardIcon,
      forwardIcon = _g === void 0 ? 'arrow-forward' : _g,
      _h = _a.forwardIconTitle,
      forwardIconTitle = _h === void 0 ? 'Show next' : _h,
      _j = _a.backwardIcon,
      backwardIcon = _j === void 0 ? 'arrow-back' : _j,
      _k = _a.backwardIconTitle,
      backwardIconTitle = _k === void 0 ? 'Show previous' : _k;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Showcase',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _l = (0, use_showcase_1.useShowcase)({
    items: children,
    distanceBetweenItems: distanceBetweenItems
  }),
      canScrollForward = _l.canScrollForward,
      canScrollBackward = _l.canScrollBackward,
      contentRef = _l.contentRef,
      scrollForward = _l.scrollForward,
      scrollBackward = _l.scrollBackward;

  var buttonStyles = (0, react_1.useMemo)(function () {
    return tslib_1.__assign({
      backgroundColor: 'white',
      boxShadow: '0px 1px 2px rgba(44, 50, 66, 0.08);'
    }, scrollIconSize === 'small' ? {
      width: '3rem',
      height: '3rem',
      padding: '1rem'
    } : {});
  }, [scrollIconSize]);
  return react_1.default.createElement(root_1.Root, {
    className: rootClasses
  }, react_1.default.createElement(sections_1.LeftSection, {
    shown: canScrollBackward,
    width: blurAreaWidth,
    blurColor: blurColor
  }, canScrollBackward && react_1.default.createElement(ui_butticon_1.Butticon, {
    isRound: true,
    isOutlined: true,
    icon: backwardIcon,
    title: backwardIconTitle,
    size: scrollIconSize,
    onClick: scrollBackward,
    style: buttonStyles
  })), react_1.default.createElement(sections_1.ContentSection, {
    ref: contentRef,
    distanceBetweenItems: distanceBetweenItems,
    distanceFromHorizontalEdges: distanceFromHorizontalEdges
  }, react_1.Children.map(children, function (child) {
    return react_1.default.createElement(sections_1.Item, null, child);
  })), react_1.default.createElement(sections_1.RightSection, {
    shown: canScrollForward,
    width: blurAreaWidth,
    blurColor: blurColor
  }, canScrollForward && react_1.default.createElement(ui_butticon_1.Butticon, {
    isRound: true,
    isOutlined: true,
    icon: forwardIcon,
    title: forwardIconTitle,
    size: scrollIconSize,
    onClick: scrollForward,
    style: buttonStyles
  })));
};

var ShowcaseWithSpace = (0, ui_helper_with_space_1.withSpace)(Showcase);
exports.Showcase = ShowcaseWithSpace;